export default __webpack_public_path__ + "e3cd194dc35d46b8fa3b5b7741b557a1-arrow-button.svg";